import { render, staticRenderFns } from "./HeaderDetails.vue?vue&type=template&id=42b7dd0a&"
import script from "./HeaderDetails.vue?vue&type=script&lang=js&"
export * from "./HeaderDetails.vue?vue&type=script&lang=js&"
import style0 from "./HeaderDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports